module.exports = __webpack_public_path__ + "img/CTWP__Staff_01.441a69ce.png";